import React, { useState, useEffect, useRef, useCallback } from "react";
import "../styles/LivePrices.css";
import SmallBox, { sarrafiyeValues } from "../components/SmallBox";
import ceyrekImage from "../assets/ziynet/ceyrek.jpg";
import yarimImage from "../assets/ziynet/yarım.jpg";
import ziynet5Image from "../assets/ziynet/ziynet5.jpg";
import image0 from "../assets/images/image0.png";

import googleImg from '../assets/mobil/google.png';
import iosImg from '../assets/mobil/ios.png';
import BottomConvertCalculator from '../components/BottomConvertCalculator';
import { Link } from "react-router-dom";

interface Price {
  code: string;
  bid: number;
  ask: number;
  category: string;
  source: string;
}

interface GoldDetail {
  name: string;
  image: string;
  description: string;
  details: { [key: string]: string | number };
}

const goldData: { [key: string]: GoldDetail } = {
  "E.ÇEYREK": {
    name: "Çeyrek Altın",
    image: ceyrekImage,
    description: "Çeyrek Altın, ziynet takı grubunun en küçük üyesidir.",
    details: {
      Cins: "Ziynet Çeyrek",
      Ağırlık: "1,754 Gram",
      Ayar: "22 Ayar",
      Çap: "18 mm",
      "Torba Adet": "610 Adet",
      "Kulpsuz Gram": "1,754 Gram",
    },
  },
  "ÇEYREK": {
    name: "Çeyrek Altın",
    image: ceyrekImage,
    description: "Çeyrek Altın, ziynet takı grubunun en küçük üyesidir.",
    details: {
      Cins: "Ziynet Çeyrek",
      Ağırlık: "1,754 Gram",
      Ayar: "22 Ayar",
      Çap: "18 mm",
      "Torba Adet": "610 Adet",
      "Kulpsuz Gram": "1,754 Gram",
    },
  },
  "E.YARIM": {
    name: "Yarım Altın",
    image: yarimImage,
    description: "Yarım Altın, ziynet takı grubunun ikinci en küçük üyesidir.",
    details: {
      Cins: "Ziynet Yarım",
      Ağırlık: "3,508 Gram",
      Ayar: "22 Ayar",
      Çap: "22 mm",
      "Torba Adet": "305 Adet",
      "Kulpsuz Gram": "3,508 Gram",
    },
  },
  "YARIM": {
    name: "Yarım Altın",
    image: yarimImage,
    description: "Yarım Altın, ziynet takı grubunun ikinci en küçük üyesidir.",
    details: {
      Cins: "Ziynet Yarım",
      Ağırlık: "3,508 Gram",
      Ayar: "22 Ayar",
      Çap: "22 mm",
      "Torba Adet": "305 Adet",
      "Kulpsuz Gram": "3,508 Gram",
    },
  },
  "ZIYNET 5": {
    name: "Ziynet 5",
    image: ziynet5Image,
    description: "Ziynet Beşli, ziynet takı grubunun en büyük üyesidir.",
    details: {
      Cins: "Ziynet Beşli",
      Ağırlık: "35,08 Gram",
      Ayar: "22 Ayar",
      Çap: "45 mm",
      "Torba Adet": "31 Adet",
      "Kulpsuz Gram": "35,08 Gram",
    },
  },
  "E.ZIYNET 5": {
    name: "Ziynet 5",
    image: ziynet5Image,
    description: "Ziynet Beşli, ziynet takı grubunun en büyük üyesidir.",
    details: {
      Cins: "Ziynet Beşli",
      Ağırlık: "35,08 Gram",
      Ayar: "22 Ayar",
      Çap: "45 mm",
      "Torba Adet": "31 Adet",
      "Kulpsuz Gram": "35,08 Gram",
    },
  },
};

const ITEMS_PER_PAGE = 15;

const LivePrices: React.FC = () => {
  const [prices, setPrices] = useState<Price[]>([]);
  const [, setPreviousPrices] = useState<{ [code: string]: Price }>({});
  const [highlightedRows, setHighlightedRows] = useState<{ [code: string]: "increase" | "decrease" | "no-change" }>({});
  const [piyasaActiveTab, setPiyasaActiveTab] = useState("ALL");
  const [sarrafiyeActiveTab, setSarrafiyeActiveTab] = useState("SARRAFIYE");
  const [selectedGold, setSelectedGold] = useState<GoldDetail | null>(null);
  const socketRef = useRef<WebSocket | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const storeImages = [
    image0,
    image0,
  
  ];

  const connectWebSocket = useCallback(() => {
    const wsUrl = "wss://sslsocket.aifanet.com/5.250.255.84/12669";

    socketRef.current = new WebSocket(wsUrl);

    socketRef.current.onopen = () => {
      console.log("WebSocket bağlantısı kuruldu.");
    };

    socketRef.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (Array.isArray(data)) {
          const updatedPrices = data.map((item: any) => ({
            code: item.Code.replace(/^E\./, 'ESKİ '), // Replace "E." prefix with "ESKİ "
            bid: item.Bid,
            ask: item.Ask,
            category: item.Category,
            source: "WebSocket",
          }));
          setPrices((prevPrices) => {
            const prevPriceMap = prevPrices.reduce((acc, price) => {
              acc[price.code] = price;
              return acc;
            }, {} as { [code: string]: Price });

            const newHighlightedRows: { [code: string]: "increase" | "decrease" | "no-change" } = {};
            updatedPrices.forEach((price) => {
              const prevBid = prevPriceMap[price.code]?.bid || 0;
              const prevAsk = prevPriceMap[price.code]?.ask || 0;

              if (price.bid !== prevBid) {
                newHighlightedRows[price.code] = price.bid > prevBid ? "increase" : "decrease";
              } else if (price.ask !== prevAsk) {
                newHighlightedRows[price.code] = price.ask > prevAsk ? "increase" : "decrease";
              } else {
                newHighlightedRows[price.code] = "no-change";
              }
            });

            setHighlightedRows(newHighlightedRows);
            setPreviousPrices(prevPriceMap);
            return updatedPrices;
          });
        }
      } catch (error) {
        console.error("WebSocket mesaj hatası:", error);
      }
    };

    socketRef.current.onclose = () => {
      console.warn("WebSocket bağlantısı kapandı. Yeniden bağlanıyor...");
      setTimeout(connectWebSocket, 5000);
    };

    socketRef.current.onerror = (error) => {
      console.error("WebSocket hata:", error);
    };
  }, []);

  useEffect(() => {
    connectWebSocket();

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === storeImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Her 3 saniyede bir resim değişecek

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
      clearInterval(interval);
    };
  }, [connectWebSocket, storeImages.length]);

  const piyasaPrices = prices.filter((price) => price.category === "PIYASA FIYATLARI");
  const sarrafiyePrices = prices.filter((price) => price.category === "SARRAFIYE");
  const gramAltinPrices = prices.filter((price) => price.category === "GRAM ALTIN");
  const gumusPrices = prices.filter((price) => price.category === "GUMUS");

  const activePiyasaPrices =
    piyasaActiveTab === "ALL"
      ? piyasaPrices
      : piyasaPrices.filter((price) => price.code.includes(piyasaActiveTab));

  const activeSarrafiyePrices =
    sarrafiyeActiveTab === "SARRAFIYE"
      ? sarrafiyePrices
      : sarrafiyeActiveTab === "GRAM ALTIN"
      ? gramAltinPrices
      : gumusPrices;

  const formatPrice = (price: number, code: string): string => {
    if (code === "EUR/USD") {
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
    } else if (["USD/KG", "EUR/KG", "GÜM/TL","GÜM/USD","GÜM/EUR", "USD/TL", "EUR/TL"].includes(code)) {
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    } else if (code.includes("GRAM") || code.includes("SARRAFIYE")) {
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } else {
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  };

  const handleGoldClick = (code: string) => {
    if (goldData[code]) {
      setSelectedGold(goldData[code]);
    }
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      setSelectedGold(null);
    }
  };

  if (selectedGold) {
    return (
      <div className="gold-detail-overlay" onClick={handleOverlayClick}>
        <div className="gold-detail-container">
          <button className="close-button" onClick={(e) => {
            e.stopPropagation();
            setSelectedGold(null);
          }}>
            ✕
          </button>
          <div className="gold-detail-content" onClick={(e) => e.stopPropagation()}>
            <div className="gold-image-container">
              <img src={selectedGold.image} alt={selectedGold.name} />
            </div>
            <div className="gold-info">
              <h2>{selectedGold.name}</h2>
              <div className="gold-specs">
                <div className="spec-item">
                  <span className="spec-label">Cins:</span>
                  <span className="spec-value">{selectedGold.details.Cins}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Ağırlık:</span>
                  <span className="spec-value">{selectedGold.details.Ağırlık}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Ayar:</span>
                  <span className="spec-value">{selectedGold.details.Ayar}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Çap:</span>
                  <span className="spec-value">{selectedGold.details.Çap}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Torba Adet:</span>
                  <span className="spec-value">{selectedGold.details["Torba Adet"]}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Kulpsuz Gram:</span>
                  <span className="spec-value">{selectedGold.details["Kulpsuz Gram"]}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="live-prices-container">
      <div className="tables-and-image">
        <div className="prices-table">
          <div className="table-header">
            <div className="tab-buttons">
              <button
                className={piyasaActiveTab === "ALL" ? "active" : ""}
                onClick={() => setPiyasaActiveTab("ALL")}
              >
                Piyasa Fiyatları
              </button>
            </div>
          </div>
          <div className="scrollable-table">
            <table>
              <thead>
                <tr>
                  <th>Birim</th>
                  <th>Alış</th>
                  <th>Satış</th>
                </tr>
              </thead>
              <tbody>
                {activePiyasaPrices.map((price) => (
                  <tr key={price.code}>
                    <td>{price.code}</td>
                    <td
                      className={
                        highlightedRows[price.code] === "increase"
                          ? "increase"
                          : highlightedRows[price.code] === "decrease"
                          ? "decrease"
                          : "no-change"
                      }
                    >
                      {formatPrice(price.bid, price.code)}
                    </td>
                    <td
                      className={
                        highlightedRows[price.code] === "increase"
                          ? "increase"
                          : highlightedRows[price.code] === "decrease"
                          ? "decrease"
                          : "no-change"
                      }
                    >
                      {formatPrice(price.ask, price.code)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="store-image">
          <img 
            src={storeImages[currentImageIndex]} 
            alt={`Store ${currentImageIndex + 1}`} 
            className="slide-image"
          />
          <div className="slide-divider"></div>
          <div className="mobile-app-links">
            <a href="https://apps.apple.com/tr/app/metal-k%C4%B1ymetli-madenler/id6741539880?l=tr" target="_blank" rel="noopener noreferrer">
              <img src={iosImg} alt="App Store" className="mobile-app-img" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img src={googleImg} alt="Google Play" className="mobile-app-img" />
            </a>
          </div>
          <div className="center-convert-calculator-container">
            <BottomConvertCalculator prices={prices} />
          </div>
        </div>
        <div className="prices-table">
          <div className="table-header">
            <div className="tab-buttons">
              <button
                className={sarrafiyeActiveTab === "SARRAFIYE" ? "active" : ""}
                onClick={() => setSarrafiyeActiveTab("SARRAFIYE")}
              >
                Sarrafiye
              </button>
              <button
                className={sarrafiyeActiveTab === "GRAM ALTIN" ? "active" : ""}
                onClick={() => setSarrafiyeActiveTab("GRAM ALTIN")}
              >
                Gram Altın
              </button>
              <button
                className={sarrafiyeActiveTab === "GUMUS" ? "active" : ""}
                onClick={() => setSarrafiyeActiveTab("GUMUS")}
              >
                Gümüş
              </button>
            </div>
          </div>
          <div className="scrollable-table">
            <table>
              <thead>
                <tr>
                  <th>Birim</th>
                  <th>Alış</th>
                  <th>Satış</th>
                </tr>
              </thead>
              <tbody>
                {activeSarrafiyePrices.map((price) => (
                  <tr 
                    key={price.code} 
                    onClick={(e) => {
                      e.preventDefault();
                      handleGoldClick(price.code);
                    }}
                  >
                    <td>{price.code}</td>
                    <td
                      className={
                        highlightedRows[price.code] === "increase"
                          ? "increase"
                          : highlightedRows[price.code] === "decrease"
                          ? "decrease"
                          : "no-change"
                      }
                    >
                      {price.category === "SARRAFIYE" && sarrafiyeValues[price.code] && (
                        <SmallBox label={price.code} type="bid" />
                      )}
                      {price.category === "GRAM ALTIN" && (
                        <SmallBox label={price.code} type="bid" />
                      )}
                      {(price.category === "SARRAFIYE" || price.category === "GRAM ALTIN" || price.category === "GUMUS")
                        ? Math.floor(price.bid).toLocaleString("tr-TR")
                        : price.bid.toFixed(2)} {price.category === "SARRAFIYE" && "₺"}
                    </td>
                    <td
                      className={
                        highlightedRows[price.code] === "increase"
                          ? "increase"
                          : highlightedRows[price.code] === "decrease"
                          ? "decrease"
                          : "no-change"
                      }
                    >
                      {price.category === "SARRAFIYE" && sarrafiyeValues[price.code] && (
                        <SmallBox label={price.code} type="ask" />
                      )}
                      {price.category === "GRAM ALTIN" && (
                        <SmallBox label={price.code} type="ask" />
                      )}
                      {(price.category === "SARRAFIYE" || price.category === "GRAM ALTIN" || price.category === "GUMUS")
                        ? Math.floor(price.ask).toLocaleString("tr-TR")
                        : price.ask.toFixed(2)} {price.category === "SARRAFIYE" && "₺"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LivePrices;
